import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

export const CarouselSection = styled.section`
  ${mobile`
    margin: 0 16px;
  `}
`;

export const CarouselHeading = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: ${-0.5 / 20}em;
  padding-bottom: 16px;
  color: ${({ theme }) => theme.colors.textDefault};
`;
